import { render } from "./ReleaseAccessCreate.vue?vue&type=template&id=7458d351"
import script from "./ReleaseAccessCreate.vue?vue&type=script&lang=js"
export * from "./ReleaseAccessCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__